var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "meta-65",
  "use": "meta-65-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\" id=\"meta-65\"><g stroke=\"#4E4E4E\" stroke-width=\"1.3\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M11 6.65a.35.35 0 0 0-.35.35v6a5.35 5.35 0 0 0 10.7 0V7a.35.35 0 0 0-.35-.35H11z\" /><path d=\"M11 25h10\" stroke-linecap=\"round\" /><path d=\"M16 18v6.464\" /><path d=\"M10.727 12.419c1.073-1.114 2.297-1.354 3.674-.719 2.066.953 6.323 2.46 6.914-.35\" stroke-linecap=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol